<template>
  <v-list-item-group v-model="selected" active-class="gray--text">
    <v-list-item v-for="(el, key) in list" :key="key" two-line>
      <v-list-item-content>
        <v-list-item-title class="font-weight-bold">
          {{ el.name }}
        </v-list-item-title>
        <v-list-item-subtitle v-if="el.description">
          {{ el.description }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list-item-group>
</template>

<script>
export default {
  name: 'TypesList',

  props: {
    list: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    selected: null
  }),

  watch: {
    selected: {
      deep: true,
      immediate: true,
      handler: 'input'
    }
  },

  methods: {
    input(value) {
      this.$emit('input', this.list[value]);
    }
  }
};
</script>

<style scoped></style>
